module.exports = __webpack_public_path__ + "img/alalmiya.1170229c.png";